import { EntityState, EntityStore, StoreConfig } from "@datorama/akita";
import { Comment } from "./comment.model";

export interface CommentsState extends EntityState<Comment> {}

@StoreConfig({ name: "comments" })
export class CommentsStore extends EntityStore<CommentsState> {}

export const commentsStore = new CommentsStore();
